export default "__VITE_ASSET__04ec7eb7__"